<div class="container-fluid  "  >
    <div class="container ">
      <div class="row">
        <div class="col-12 justify-content-center align-content-center style">
          <div class="justify-content-center align-content-center text-center" >
            <img src="/assets/images/verify-account/Group 38204@2x.svg" style="width: 163.36px; height: 156.09px;"/>
          <h3 style="font-size: 26px; font-weight: 600; line-height: 37px;" class="mt-4"> Verify Your Email Address </h3>
          <p style="font-size: 18px; font-weight: 500; line-height: 30px;" class="mt-3"> Thank you signing up with grammarin. Before we process, we need <br>
            to verify your email address to complete your registration. <br>
            If you did not receive the email. Please check your spam folder as well.</p>
              <p style="color: #007bff; cursor: pointer;" (click)="againsent_code()">Click here to request another</p>
          </div>


        </div>
      </div>

           <div
           *ngIf="resendEmail"
           class="backdrop"
           style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5); z-index: 1000;">
         </div>


         <div
           *ngIf="resendEmail"
           class="content-div"
           style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);          width: 468px;
           height: 360px;
            background-color: white; z-index: 1010; border-radius: 4px; border: 1px solid  white ;">

           <div class="text-center" style="    margin-top: 9%;">
             <img src="/assets/images/verify-account/Group 38204@2x.svg"/>

             <div style="       width: 440px;
             height: 64px;
             margin-left: 16px;">
              <p
               class="error mt-4"
               style="   font-size: 24px;
               font-weight: 500;
               line-height: 33.89px;
           ">
               {{send }}
             </p>
             </div>

             <button
               class="mt-2 butn-alert"
               (click)="closesendDiv()">Ok</button>
           </div>
         </div>

  <div
  *ngIf="error"
  class="backdrop"
  style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5); z-index: 1000;">
</div>


<div
  *ngIf="error"
  class="content-div"
  style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);          width: 468px;
  height: 360px;
   background-color: white; z-index: 1010; border-radius: 4px; border: 1px solid  white ;">

  <div class="text-center" style="    margin-top: 9%;">
    <img src="/assets/images/paraphrasing tool/alert.svg"/>

    <div style="       width: 440px;
    height: 64px;
    margin-left: 16px;">
     <p
      class="error mt-4"
      style="   font-size: 24px;
      font-weight: 500;
      line-height: 33.89px;
  ">
      {{ errorAlerts }}
    </p>
    </div>

    <button
      class="mt-4 butn-alert"
      (click)="closeErrorDiv()">Ok</button>
  </div>
</div>


<div
*ngIf="success"
class="backdrop"
style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.5); z-index: 1000;">
</div>


<div
*ngIf="success"
class="content-div"
style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%);           width: 468px;
height: 360px; background-color: white; z-index: 1010; border-radius: 4px; border: 1px solid white;">

<div class="text-center" style="    margin-top: 9%;">
  <img src="/assets/images/paraphrasing tool/success.svg" style="width: 138px; height: 138px;"/>

  <p
  *ngIf="success"
    class="error mt-4"
    style="   font-size: 24px;
    font-weight: 500;
    line-height: 33.89px
;
;">
    {{ successAlert}}
  </p>

</div>
</div>

      </div>
    </div>
